/**
 * user - auth
 *
 * @author Shigq
 * @date 2021/6/21 10:46
 */
import { t, fileComp } from '../base'

const annualSalesOptions = [
  { label: t('dict.annualSales.A'), value: 'A' },
  { label: t('dict.annualSales.B'), value: 'B' },
  { label: t('dict.annualSales.C'), value: 'C' },
  { label: t('dict.annualSales.D'), value: 'D' },
  { label: t('dict.annualSales.E'), value: 'E' }
]
const companyScaleOptions = [
  { label: t('dict.companyScale.1'), value: '1' },
  { label: t('dict.companyScale.2'), value: '2' },
  { label: t('dict.companyScale.3'), value: '3' },
  { label: t('dict.companyScale.4'), value: '4' },
  { label: t('dict.companyScale.5'), value: '5' },
  { label: t('dict.companyScale.6'), value: '6' }
]
const transModeOptions = [
  { label: t('dict.transMode.1'), value: '1' },
  { label: t('dict.transMode.2'), value: '2' },
  { label: t('dict.transMode.3'), value: '3' },
  { label: t('dict.transMode.4'), value: '4' },
  { label: t('dict.transMode.5'), value: '5' },
  { label: t('dict.transMode.6'), value: '6' },
  { label: t('dict.transMode.7'), value: '7' },
  { label: t('dict.transMode.8'), value: '8' },
]
const tradeOpponentOptions = [
  { label: t('dict.tradeOpponent.US'), value: '美国' },
  { label: t('dict.tradeOpponent.CA'), value: '加拿大' },
  { label: t('dict.tradeOpponent.GB'), value: '英国' },
  { label: t('dict.tradeOpponent.EU'), value: '欧元区国家' },
  { label: t('dict.tradeOpponent.HK'), value: '中国香港' },
  { label: t('dict.tradeOpponent.SG'), value: '新加坡' },
  { label: t('dict.tradeOpponent.JP'), value: '日本' },
  { label: t('dict.tradeOpponent.AU'), value: '澳洲' },
  { label: t('dict.tradeOpponent.NZ'), value: '新西兰' },
  { label: 'Other', value: 'Other' }
]
const transCurOptions = [
  { label: 'CNY/CNH', value: 'CNY/CNH' },
  { label: 'USD', value: 'USD' },
  { label: 'EUR', value: 'EUR' },
  { label: 'GBP', value: 'GBP' },
  { label: 'JPY', value: 'JPY' },
  { label: 'HKD', value: 'HKD' },
  { label: 'CAD', value: 'CAD' },
  { label: 'SGD', value: 'SGD' },
  { label: 'AUD', value: 'AUD' },
  { label: 'NZD', value: 'NZD' },
  { label: 'Other', value: 'Other' },
]
const eptMonthAmtOptions = [
  { label: t('dict.eptMonthAmt.1'), value: '1' },
  { label: t('dict.eptMonthAmt.2'), value: '2' },
  { label: t('dict.eptMonthAmt.3'), value: '3' },
  { label: t('dict.eptMonthAmt.4'), value: '4' },
  { label: t('dict.eptMonthAmt.5'), value: '5' },
  { label: t('dict.eptMonthAmt.6'), value: '6' },
  { label: t('dict.eptMonthAmt.7'), value: '7' },
  { label: t('dict.eptMonthAmt.8'), value: '8' }
]
const fxTxnStatus = {
  '01': t('dict.fxTxnStatus.01'),
  '02': t('dict.fxTxnStatus.02'),
  '03': t('dict.fxTxnStatus.03'),
  '04': t('dict.fxTxnStatus.04'),
  '05': t('dict.fxTxnStatus.05'),
  '09': t('dict.fxTxnStatus.09'),
  20: t('dict.fxTxnStatus.20'),
  30: t('dict.fxTxnStatus.30'),
}
const fxStatTag = {
  '01': 'primary',
  '02': 'primary',
  '03': 'primary',
  '04': 'warning',
  '05': 'warning',
  '09': 'success',
  20: 'primary',
  30: 'primary',
}
const onsite = {
  '1': t('dict.onsite.1'),
  '0': t('dict.onsite.0')
}
const cascade = {
  transMode: {
    // 进口B2B
    1: {
      1: t('cascade.transMode.1.1'),
      2: t('cascade.transMode.1.2'),
      3: t('cascade.transMode.1.3'),
      4: t('cascade.transMode.1.4'),
      5: t('cascade.transMode.1.5'),
      6: t('cascade.transMode.1.6'),
      7: t('cascade.transMode.1.7'),
      8: t('cascade.transMode.1.8'),
      9: t('cascade.transMode.1.9'),
      10: t('cascade.transMode.1.10'),
      11: t('cascade.transMode.1.11'),
      12: t('cascade.transMode.1.12'),
      13: t('cascade.transMode.1.13'),
      14: t('cascade.transMode.1.14'),
      15: t('cascade.transMode.1.15'),
      16: t('cascade.transMode.1.16'),
      17: t('cascade.transMode.1.17'),
      18: t('cascade.transMode.1.18'),
      19: t('cascade.transMode.1.19'),
      20: t('cascade.transMode.1.20'),
      21: t('cascade.transMode.1.21'),
      22: t('cascade.transMode.1.22'),
    },
    // 出口B2B
    2: {
      1: t('cascade.transMode.2.1'),
      2: t('cascade.transMode.2.2'),
      3: t('cascade.transMode.2.3'),
      4: t('cascade.transMode.2.4'),
      5: t('cascade.transMode.2.5'),
      6: t('cascade.transMode.2.6'),
      7: t('cascade.transMode.2.7'),
      8: t('cascade.transMode.2.8'),
      9: t('cascade.transMode.2.9'),
      10: t('cascade.transMode.2.10'),
      11: t('cascade.transMode.2.11'),
      12: t('cascade.transMode.2.12'),
      13: t('cascade.transMode.2.13'),
      14: t('cascade.transMode.2.14'),
      15: t('cascade.transMode.2.15'),
      16: t('cascade.transMode.2.16'),
      17: t('cascade.transMode.2.17'),
      18: t('cascade.transMode.2.18'),
      19: t('cascade.transMode.2.19'),
      20: t('cascade.transMode.2.20'),
      21: t('cascade.transMode.2.21'),
      22: t('cascade.transMode.2.22')
    },
    // 出口电商
    3: {
      1: t('cascade.transMode.3.1'),
      2: t('cascade.transMode.3.2'),
      3: t('cascade.transMode.3.3'),
      4: t('cascade.transMode.3.4'),
      5: t('cascade.transMode.3.5'),
      6: t('cascade.transMode.3.6'),
      7: t('cascade.transMode.3.7'),
      8: t('cascade.transMode.3.8'),
      9: t('cascade.transMode.3.9'),
      10: t('cascade.transMode.3.10'),
      11: t('cascade.transMode.3.11'),
      12: t('cascade.transMode.3.12'),
      99: t('cascade.transMode.3.99')
    },
    // 进口电商
    4: {
      1: t('cascade.transMode.4.1'),
      2: t('cascade.transMode.4.2'),
      3: t('cascade.transMode.4.3'),
      4: t('cascade.transMode.4.4'),
      5: t('cascade.transMode.4.5'),
      6: t('cascade.transMode.4.6'),
      7: t('cascade.transMode.4.7'),
      8: t('cascade.transMode.4.8'),
      9: t('cascade.transMode.4.9'),
      10: t('cascade.transMode.4.10'),
      11: t('cascade.transMode.4.11'),
      12: t('cascade.transMode.4.12'),
      99: t('cascade.transMode.4.99')
    },
    // 教育
    5: {
      1: t('cascade.transMode.5.1'),
      2: t('cascade.transMode.5.2'),
      99: t('cascade.transMode.5.99')
    },
    // 航旅
    6: {
      1: t('cascade.transMode.6.1'),
      2: t('cascade.transMode.6.2'),
      3: t('cascade.transMode.6.3'),
      99: t('cascade.transMode.6.99'),
    },
    // 服务贸易
    7: {
      1: t('cascade.transMode.7.1'),
      2: t('cascade.transMode.7.2'),
      3: t('cascade.transMode.7.3'),
      4: t('cascade.transMode.7.4'),
      5: t('cascade.transMode.7.5'),
      99: t('cascade.transMode.7.99')
    },
    // 同业机构
    8: {
      1: t('cascade.transMode.8.1'),
      2: t('cascade.transMode.8.2')
    }
  }
}
const accountStatus = {
  3: t('client.accountStatus.text_1'),
  1: t('client.accountStatus.text_2'),
  0: t('client.accountStatus.text_3'),
  9: t('client.accountStatus.text_4'),
  2: t('client.accountStatus.text_5'),
  4: t('client.accountStatus.text_6'),
  5: t('client.accountStatus.text_7'),
  6: t('client.accountStatus.text_8'),
}
const statTag = {
  3: 'success',
  1: 'success',
  0: 'danger',
  9: 'warning',
  2: 'success',
  4: 'danger',
  5: 'info',
  6: 'danger',
}
const curEnum = [
  "USD",
  "CNH",
  "CNY",
  "HKD",
  "GBP",
  "EUR",
  "JPY",
  "CAD",
  "AUD",
  "NZD",
  "SGD",
  "CHF",
  "AED",
  "THB",
  "SEK",
  "NOK",
  "VND",
  "MYR",
  "PHP",
  "KRW",
  "IDR",
  "BHD",
  "ZAR",
  "KES",
];

export {
  annualSalesOptions,
  companyScaleOptions,
  transModeOptions,
  tradeOpponentOptions,
  transCurOptions,
  eptMonthAmtOptions,
  cascade,
  curEnum,
  accountStatus,
  statTag,
  onsite,
  fxTxnStatus,
  fxStatTag
}
